import { styled } from 'styled-components';

import Field from '../Field';
import { Box } from '@cof/plastic-components';

const Group = styled(Box)`
    padding: 0;
    border: 0;
    margin: 0;
    display: block;

    &:last-child {
        margin-bottom: 0;
    }

    & > ${Field} {
        margin-bottom: ${({ theme }: any) => theme.space.sm};

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

Group.displayName = 'Group';

export default Group;
